
import TranResourcesApi from './src/Tranresources'
import ErrorLogApi from './src/ErrorLogApi'


let apis = {
   TranResourcesApi,
   ErrorLogApi
};

export default apis;
